import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, ErrorHandler } from '@angular/core'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'

// Prime NG
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'

// KIM parts
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { GlobalErrorHandler } from '@services/global-error-handler'
import { LoaderComponent } from './components/loader/loader.component'
import { LoaderService } from '@services/loader.service'

import { KimTeilnehmerRestApi } from '@core/service/kim-teilnehmer-rest-api'
import { BasicAuthInterceptor } from '@auth/basic-auth.interceptor'
import { ServerErrorInterceptor } from '@core/interceptors/server-error.interceptor'
import { ErrorComponent } from './components/error/error.component'

@NgModule({
  declarations: [AppComponent, LoaderComponent, ErrorComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,

    ProgressSpinnerModule,
    DialogModule,
    ButtonModule,
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    KimTeilnehmerRestApi,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
